import { useState } from "react";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import { Link } from "react-router-dom";

import { CommentsDialog } from "../../comments";
import { useNotification } from "../../../notifications";
import { contabiliumService } from "../../../../services";

export function AttachmentsChip({
  order,
  showDelivery,
  showDelivery2,
  showPresupuesto,
  showImages,
}) {
  const { displayNotification } = useNotification();
  const [openComments, setOpenComments] = useState(false);

  const getComprobantePDF = (e, idComprobante) => {
    e.preventDefault();
    contabiliumService.getComprobantePDF(idComprobante).then(
      (f) => console.log(f),
      (err) => {
        displayNotification({
          message: "No se puede obtener la factura desde Contabilium",
          type: "error",
        });
        console.log(err);
      },
    );
  };

  function handleChipClick(e) {
    e.preventDefault();
    showImages(order.attachments);
  }

  const handleDeliveryClick = (e) => {
    e.preventDefault();
    showDelivery(order.id);
  };

  const handleDeliveryClick2 = (e) => {
    e.preventDefault();
    showDelivery2(order.id);
  };

  const handlePresupuestoClick = (e) => {
    e.preventDefault();
    showPresupuesto(order.id);
  };

  const linkStyle = { textDecoration: "none", fontSize: "1.5em" };
  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={true}>
          {order.attachments !== null && (
            <Tooltip title="Ver Adjuntos">
              <span>
                <Link style={linkStyle} onClick={handleChipClick}>
                  📎
                </Link>
              </span>
            </Tooltip>
          )}
        </Grid>
        <Grid item xs={true}>
          {order.deliveries.length > 0 && (
            <Tooltip title="Ver Remito">
              <span>
                <Link style={linkStyle} onClick={handleDeliveryClick}>
                  🚚
                </Link>
              </span>
            </Tooltip>
          )}
        </Grid>
        <Grid item xs={true}>
          {order.remitoAdjunto && (
            <Tooltip title="Ver Remito">
              <span>
                <Link style={linkStyle} onClick={handleDeliveryClick2}>
                  🚛
                </Link>
              </span>
            </Tooltip>
          )}
        </Grid>
        <Grid item xs={true}>
          {order.presupuestoAdjunto && (
            <Tooltip title="Ver Presupuesto">
              <span>
                <Link style={linkStyle} onClick={handlePresupuestoClick}>
                  📃
                </Link>
              </span>
            </Tooltip>
          )}
        </Grid>
        <Grid item xs={true}>
          {order.comprobanteContabilium !== null && (
            <Tooltip title="Ver Factura">
              <span>
                <Link
                  style={linkStyle}
                  onClick={(e) =>
                    getComprobantePDF(e, order.comprobanteContabilium)
                  }
                >
                  💲
                </Link>
              </span>
            </Tooltip>
          )}
        </Grid>
        <Grid item xs={true}>
          {order.comments.length > 0 && (
            <Tooltip title="Comentarios">
              <span>
                <Link style={linkStyle} onClick={(e) => setOpenComments(true)}>
                  💬
                </Link>
              </span>
            </Tooltip>
          )}
        </Grid>
      </Grid>
      <CommentsDialog
        openComments={openComments}
        order={order}
        handleCloseComments={() => setOpenComments(false)}
      />
    </>
  );
}
